import loadable from "@loadable/component";
import SwitchTab from "../../components/Reusable/SwitchTab";
import APIS from "../../constant/Endpoint";
import usePatchHook from "../../customHooks/usePatchHook";
const ProductGroupListComponent = loadable(
  () => import("../../components/InventoryInfo/ProductGroupList")
);

const ProductGroupList = () => {
  const tabs = [
    {
      id: "inventory-info",
      label: "Inventory",
      href: "/accounting/inventory",
    },
    {
      id: "product-group",
      label: "Product Group",
      href: "/accounting/product-group",
    },
  ];

  const { mutateAsync: patchUser, isLoading } = usePatchHook({
    queryKey: ["category"],
  });

  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.CATEGORY}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <>
      <SwitchTab tabs={tabs} />
      <ProductGroupListComponent handleIsActive={handleIsActive} />
    </>
  );
};

export default ProductGroupList;
